"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialize = exports.AsyncDynamicValues = void 0;
const interpreter_1 = require("./interpreter");
const context_1 = require("./interpreter/context");
const types_1 = require("./types");
const utils_1 = require("./utils");
class AsyncDynamicValues {
    constructor(defaults, environment, handlers) {
        // tslint:disable: member-ordering
        this.getBoolean = this.getValueOfType(types_1.ValueNodeReturnType.Boolean, utils_1.isBoolean);
        this.getJson = this.getValueOfType(types_1.ValueNodeReturnType.Json, utils_1.isJson);
        this.getString = this.getValueOfType(types_1.ValueNodeReturnType.String, utils_1.isString);
        this.getFloat = this.getValueOfType(types_1.ValueNodeReturnType.Float, utils_1.isFloat);
        this.getInt = this.getValueOfType(types_1.ValueNodeReturnType.Int, utils_1.isInteger);
        this.defaults = defaults;
        this.environment = environment;
        this.handlers = handlers;
    }
    async featureFlag(name, on, off, context) {
        const defaultValue = this.defaults[name];
        if (typeof defaultValue !== 'boolean') {
            const error = utils_1.mismatchedDefaultError('boolean', name.toString());
            this.handlers.sendError(error);
            return Promise.reject(error);
        }
        try {
            const resolvedValue = await this.interpret(name, context, types_1.ValueNodeReturnType.Boolean, defaultValue, utils_1.isBoolean);
            return resolvedValue ? on() : off();
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    // tslint:enable: member-ordering
    /**
     * Helper function to wrap a call to `interperet` with default value
     * type checking.
     *
     * @param isValidDefault Function to verify that the default value matches the
     *  desired type.
     * @param type ValueNodeReturnType corresponding to the desired value type
     */
    getValueOfType(type, typeValidator) {
        return (name, context) => {
            const defaultValue = this.defaults[name];
            if (!typeValidator(defaultValue)) {
                const error = utils_1.mismatchedDefaultError(type.toString(), name.toString());
                this.handlers.sendError(error);
                return Promise.reject(error);
            }
            return this.interpret(name, context, type, defaultValue, typeValidator);
        };
    }
    async interpret(name, context, type, defaultValue, typeValidator) {
        let config = null;
        try {
            config = await this.handlers.getOnlineConfiguration(this.environment.serviceName, name, this.environment.onlineConfigPrefix);
        }
        catch (e) {
            // TODO: track unreadable config error?
            // Intentionally leave `config = null` to return default value
        }
        if (config == null) {
            return Promise.resolve(defaultValue);
        }
        if (type !== config.default.returnType) {
            const error = `Attempted to grab type ${type} for Dynamic Value
         ${name} which is of type ${config.default.returnType}`;
            this.handlers.sendError(error);
            return Promise.reject(error);
        }
        const { value, trackingData } = interpreter_1.interpret(config, new context_1.Context(this.environment, context, name, this.handlers.sendError, config.bucketingMethod), typeValidator);
        if (utils_1.shouldTrack(config)) {
            this.handlers.trackExposure({
                calling_context: 'JS DVL',
                bucket_key: '',
                bucket_key_type: '',
                experiment_name: name,
                experiment_version: `${config.version || 'unknown version'}`,
                service: `${this.environment.serviceName}`,
                result: JSON.stringify(value),
                tag: '',
                resolution_log: [],
                exposure_time: Date.now(),
                ...trackingData,
            });
        }
        return Promise.resolve(value == null ? defaultValue : value);
    }
}
exports.AsyncDynamicValues = AsyncDynamicValues;
/**
 * Initialize function exposed to clients accessing this library
 * @param node
 * @param context
 */
function initialize(defaults, environment, handlers) {
    return new AsyncDynamicValues(defaults, environment, handlers);
}
exports.initialize = initialize;
//# sourceMappingURL=asyncDynamicValues.js.map